import { Controller } from 'stimulus'

import { fetchPlans, getPlanPriceValueByKey } from '../base/plans'
import Observable from '../utils/observable'
import FormController from '../../_components/form/form_controller'
import SnackBar from '../../_components/snackbar/snackbar'

const CONTROLLER_IDENTIFIER = 'plans-controller'

export const getPlansController = (application) => {
  const controllerElement = document.querySelector(`.${CONTROLLER_IDENTIFIER}`)

  if (!controllerElement) {
    return null
  }

  const plansController = application.getControllerForElementAndIdentifier(controllerElement, 'plans')
  return plansController
}

export default class Plans extends Controller {
  selectedCurrency = null

  plans = null

  observable = new Observable()

  async connect() {
    this.element.classList.add(CONTROLLER_IDENTIFIER)

    const { data, errors } = await fetchPlans()

    if (data) {
      this.plans = data
      this.observable.setState({ plans: data, currency: this.selectedCurrency })
    }

    if (errors.length > 0) {
      // eslint-disable-next-line no-new
      new SnackBar('Something went wrong when fetching the payment plans, please try again later', {
        modifiers: 'error',
        autoHide: true,
        duration: FormController.ALERT_DURATION,
        position: 'top',
      })
    }
  }

  setCurrency(e) {
    const { currency } = e.detail

    this.selectedCurrency = currency

    /**
     * If the prices data have been saved
     * and a currency is set. Then we should
     * update the prices
     */
    if (this.plans) {
      this.observable.setState({ plans: this.plans, currency: this.selectedCurrency })
    }
  }

  getPlanPrice(key) {
    if (!this.plans || !this.selectedCurrency) {
      /**
       * If either the prices or the selected currency is not set
       * we aren't able to obtain any price. Therefore we return nothing
       */
      return null
    }

    return getPlanPriceValueByKey(this.plans, key, this.selectedCurrency)
  }

  getObservable() {
    return this.observable
  }
}
